import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { EMPLY_CUPOS_NOMINADOS } from '../../actions/constants'
import { TABLE_CUPOS_NOMINADOS } from '../../../../config/tables'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { reduxForm } from 'redux-form'
import { FORM_CUPO } from '../../../../config/forms'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarTablaCuposNominados } from '../../actions'

function TablaCuposNominados (props) {
  const { actualizarTablaCuposNominados, roles } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CORREDOR' || roles === 'CARGADOR' || roles === 'EXPORTADOR_CONSULTA')
    actualizarTablaCuposNominados(new Date(), new Date(), rol)
  }, [actualizarTablaCuposNominados, roles])

  const actualizarFechas = (fechaD, fechaH) => {
    const { roles } = props
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CORREDOR' || roles === 'CARGADOR' || roles === 'EXPORTADOR_CONSULTA')
    actualizarTablaCuposNominados(fechaD, fechaH, rol)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <div>
        <MuiTable id={TABLE_CUPOS_NOMINADOS} />
        <br />
      </div>
    </>
  )
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = ({
  actualizarTablaCuposNominados
})

export default reduxForm({
  form: FORM_CUPO,
  initialValues: EMPLY_CUPOS_NOMINADOS,
  enableReinitialize: true
})(connect(mapStateToProps, mapActionsToProps)(TablaCuposNominados))
